import React from 'react';
import PropTypes from 'prop-types';
import Divider from 'material-ui/Divider';
import { withStyles } from 'material-ui/styles/index';

const styles = () => ({
    divider: {
        marginTop: '16px',
    },
});

function DrawerDivider(props) {
    return (
        <Divider className={props.classes.divider} />
    );
}

DrawerDivider.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DrawerDivider);



// WEBPACK FOOTER //
// ./src/app/common/components/Drawer/DrawerDivider.js